"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/Controls/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _BatchControls = require('./BatchControls'); var _BatchControls2 = _interopRequireDefault(_BatchControls);
var _AddPatients = require('./AddPatients'); var _AddPatients2 = _interopRequireDefault(_AddPatients);













const CampaignControls = ({
  campaignKey,
  isCampaignArchived,
  onPauseCampaign,
  onQueueMessages,
  onEditMessage,
  onAddExisting,
  onAddFromCsv,
  activePanel = null,
}) => (
  _react2.default.createElement('div', { className: "campaign-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
    , _react2.default.createElement(_BatchControls2.default, {
      campaignKey: campaignKey,
      onPauseCampaign: onPauseCampaign,
      onQueueMessages: onQueueMessages, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
    )
    , _react2.default.createElement(_AddPatients2.default, {
      campaignKey: campaignKey,
      isDisabled: isCampaignArchived,
      onEditMessage: onEditMessage,
      onAddExisting: onAddExisting,
      onAddFromCsv: onAddFromCsv,
      activePanel: activePanel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
    )
  )
)

exports. default = CampaignControls
